var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"msg-list"},[_c('div',{staticClass:"table-bd"},[_c('custom-table',{attrs:{"tableCode":"role_msg_list","data":_vm.tableList,"height":"100%"},on:{"filter":_vm.filterChange,"sort":_vm.sortChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }